import { PendoService } from '@patient-ui/patient-web/store';

import { FindALabTrackingContextService } from './find-a-lab-tracking-context.service';
import {
  computeDaysBetween,
  slotDateString,
} from '../utils/find-a-lab-search-event.util';

export interface HeldAppointmentForTracking {
  locationId: number;
  slot: string;
  serviceId: number;
}

export function trackStandardAppointmentScheduled(options: {
  pendoService: PendoService;
  trackingContextService: FindALabTrackingContextService;
  heldAppointment: HeldAppointmentForTracking;
  paidBy: string;
  todayDateString: string;
}): void {
  const trackingContext = options.trackingContextService.read();
  const bookedSlot = options.heldAppointment.slot;
  const bookedDate = slotDateString(bookedSlot);
  const preferredDate = trackingContext?.preferred_date;
  const zip = trackingContext?.zip;

  options.pendoService.trackAppointmentScheduled({
    locationId: options.heldAppointment.locationId,
    booked_slot: bookedSlot,
    service: options.heldAppointment.serviceId,
    paidBy: options.paidBy,
    days_out_from_today: computeDaysBetween(
      options.todayDateString,
      bookedDate
    ),
    ...(preferredDate
      ? {
          preferred_date: preferredDate,
          days_search_to_booking: computeDaysBetween(preferredDate, bookedDate),
        }
      : { search_context_missing: true }),
    ...(zip && { zip }),
  });
  options.trackingContextService.clear();
}
